import axios from "axios";

const axiosInstance = axios.create({
  //baseURL: "https://teach-backend.bigbooster.in/",
  baseURL: "https://teachbackendapi.utkarshpublications.com/",
});

export default axiosInstance;
